import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const textualStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "20px 16px",
  background: "var(--color-surface-1)",
  border: "1px solid rgba(255, 255, 255, 0.05)",
  lineHeight: "1.9",
  color: "var(--color-text-secondary)",
  borderRadius: "12px",
};

const cardStyle = {
  background: "var(--color-surface-2)",
  padding: "20px",
  borderRadius: "12px",
  marginBottom: "20px",
  border: "1px solid rgba(255, 255, 255, 0.05)",
};

const ContactUs = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);
  return (
    <div style={textualStyle}>
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <h2
          style={{
            fontSize: "2.2rem",
            color: "var(--color-text-primary)",
            marginBottom: "8px",
          }}
        >
          Contact Us
        </h2>
        <h3
          style={{
            fontSize: "1.3rem",
            color: "#f97316",
            fontWeight: "600",
          }}
        >
          Regard Traders – Business Support & Trade Desk
        </h3>
      </div>

      {/* Network Operations */}
      <div style={cardStyle}>
        <h4 style={{ color: "#f97316", marginBottom: "12px", fontSize: "1.1rem" }}>
          Hamare Office, Desk & Logistics Network
        </h4>
        <p style={{ margin: "0 0 12px 0" }}>
          <strong style={{ color: "var(--color-text-primary)" }}>
            Operations & Merchant Calling Desk (Delhi):
          </strong>{" "}
          Rohini Sector 19, New Delhi - 110089, India (Order Verification, Retailer Calling Support & Trade Coordination)
        </p>
        <p style={{ margin: "0 0 12px 0" }}>
          <strong style={{ color: "var(--color-text-primary)" }}>
            Registered Corporate Office (Chhattisgarh):
          </strong>{" "}
          Near District Education Office, Kawardha, Kabirdham, Chhattisgarh - 491995 (Statutory Billing, MSME Registration & Legal Base)
        </p>
        <p style={{ margin: "0 0 12px 0" }}>
          <strong style={{ color: "var(--color-text-primary)" }}>
            Sourcing Network:
          </strong>{" "}
          Direct tie-ups with verified manufacturers across Delhi NCR, Surat, Mumbai & primary national trade hubs.
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "var(--color-text-primary)" }}>
            Pan-India Delivery Network:
          </strong>{" "}
          Desh ke har kone (har rajya, kasbe aur gaon) mein registered cargo aur trusted logistics partners ke zariye door-step delivery suvidha.
        </p>
      </div>

      {/* Customer & Wholesale Trade Desk */}
      <h3
        style={{
          color: "var(--color-text-primary)",
          marginTop: "30px",
          marginBottom: "15px",
          borderLeft: "4px solid #f97316",
          paddingLeft: "12px",
          fontSize: "1.25rem",
        }}
      >
        Customer & Wholesale Trade Desk
      </h3>
      <div style={cardStyle}>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>WhatsApp & Calling Desk:</strong>{" "}
          <a
            href="https://wa.me/917222994585"
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--color-text-primary)", textDecoration: "underline" }}
          >
            +91 72229 94585
          </a>{" "}
          (Monday to Saturday, 10:00 AM to 7:00 PM)
        </p>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Customer & Order Support:</strong>{" "}
          <a
            href="mailto:support@regardtraders.in"
            style={{ color: "var(--color-text-primary)", textDecoration: "underline" }}
          >
            support@regardtraders.in
          </a>
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "#f97316" }}>General Trade Inquiries:</strong>{" "}
          <a
            href="mailto:info@regardtraders.in"
            style={{ color: "var(--color-text-primary)", textDecoration: "underline" }}
          >
            info@regardtraders.in
          </a>
        </p>
      </div>

      {/* Statutory Grievance Redressal Desk */}
      <h3
        id="grievance-redressal"
        style={{
          color: "var(--color-text-primary)",
          marginTop: "35px",
          marginBottom: "15px",
          borderLeft: "4px solid #f97316",
          paddingLeft: "12px",
          fontSize: "1.25rem",
        }}
      >
        Statutory Grievance Redressal Desk (As per Consumer Protection E-Commerce Rules)
      </h3>
      <div style={cardStyle}>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Grievance Officer:</strong> JAISZ
        </p>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Designation:</strong> Head – Trade Operations & Compliance
        </p>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Official Email:</strong>{" "}
          <a
            href="mailto:jaisz@regardtraders.in"
            style={{ color: "var(--color-text-primary)", textDecoration: "underline" }}
          >
            jaisz@regardtraders.in
          </a>
        </p>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Direct Escalation Line / WhatsApp:</strong>{" "}
          <a
            href="https://wa.me/917222994585"
            target="_blank"
            rel="noreferrer"
            style={{ color: "var(--color-text-primary)", textDecoration: "underline" }}
          >
            +91 72229 94585
          </a>
        </p>
        <p style={{ margin: "0 0 10px 0" }}>
          <strong style={{ color: "#f97316" }}>Working Hours:</strong> Monday to Saturday, 10:00 AM to 7:00 PM
        </p>
        <p style={{ margin: 0 }}>
          <strong style={{ color: "#f97316" }}>Resolution SLA:</strong> Shikayat darj hone ke 48 ghante ke andar confirmation aur 15 business dinon ke andar final resolution.
        </p>
      </div>
    </div>
  );
};

export default ContactUs;
